import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Navbar({ user, onSignOut, dashboardPath }) {
  const navigate = useNavigate();
  const [dashHover, setDashHover] = useState(false);

  const linkStyle = {
    color: 'rgba(255,255,255,0.85)',
    fontSize: 13,
    fontWeight: 500,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '6px 10px',
    borderRadius: 8,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
  };


  return (
    <>
    <nav style={{
      background: '#0F2C4E',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      borderBottom: '1px solid rgba(255,255,255,0.08)',
    }}>
      <div className="navbar-row" style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        height: 56, paddingLeft: 24, paddingRight: 24,
      }}>
        {/* Left — RenterRep wordmark */}
        <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
          <span className="navbar-wordmark" style={{ fontFamily: "'DM Serif Display', serif", fontSize: 22, color: '#FFFFFF', letterSpacing: '-0.3px' }}>
            Renter<span style={{ color: '#C9972A' }}>Rep</span>
          </span>
        </button>

        {/* Right — nav buttons */}
        <div className="navbar-links" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <button onClick={() => navigate('/about')} style={linkStyle}>About Us</button>
          <button onClick={() => navigate('/pricing')} style={linkStyle}>Pricing</button>
          <a href="mailto:support@renterrep.com" style={linkStyle}>Contact</a>
          {user ? (
            <>
              {/* Dashboard w/ hover dropdown showing who's logged in */}
              <div
                style={{ position: 'relative' }}
                onMouseEnter={() => setDashHover(true)}
                onMouseLeave={() => setDashHover(false)}
              >
                <button onClick={() => navigate(dashboardPath || '/dashboard')} style={linkStyle}>Dashboard ▾</button>
                {dashHover && (
                  <div style={{
                    position: 'absolute', top: '100%', right: 0, marginTop: 4,
                    background: '#FAF6EC', border: '1px solid rgba(184,137,58,0.35)',
                    borderRadius: 12, boxShadow: '0 8px 24px rgba(15,44,78,0.25)',
                    padding: '12px 16px', minWidth: 180, zIndex: 200,
                  }}>
                    <div style={{ fontSize: 10, color: '#B8893A', letterSpacing: '0.12em', textTransform: 'uppercase', fontWeight: 700, marginBottom: 4 }}>Signed in as</div>
                    <div style={{ fontSize: 14, color: '#0F2C4E', fontWeight: 700, marginBottom: 8 }}>
                      {user.name || user.email}
                    </div>
                    <span style={{
                      display: 'inline-block',
                      fontSize: 10, fontWeight: 800, letterSpacing: '0.06em', textTransform: 'uppercase',
                      color: '#0F2C4E', border: '1.5px solid #0F2C4E', padding: '2px 8px', borderRadius: 20,
                    }}>
                      {user.role === 'manager' ? 'Property Management' : 'Tenant'}
                    </span>
                  </div>
                )}
              </div>
              <button
                onClick={onSignOut}
                style={{
                  marginLeft: 6,
                  background: 'transparent',
                  color: 'rgba(255,255,255,0.85)',
                  border: '1.5px solid rgba(255,255,255,0.35)',
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: 'pointer',
                  padding: '6px 14px',
                  borderRadius: 50,
                }}
              >
                Sign Out
              </button>
            </>
          ) : (
            <>
              <button onClick={() => navigate('/login')} style={linkStyle}>Log In</button>
              <button
                onClick={() => navigate('/signup')}
                style={{
                  marginLeft: 6,
                  background: '#C9972A',
                  color: '#fff',
                  border: 'none',
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: 'pointer',
                  padding: '7px 14px',
                  borderRadius: 50,
                }}
              >
                Sign Up
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
    </>
  );
}
